export const masterApiUrl = {
    getDistributionCentreData: "/api/v1/hrm/master/distribution-centre",
    getDistributionCentreDataSort: "/api/v1/hrm/master/distribution-centre/sort",
    getDcType: '/api/v1/hrm/master/dcType',
    getBusinessUnit: '/api/v1/hrm/master/businessUnit',
    getCountries: '/api/v1/hrm/master/countries/search/all',
    getStates: '/api/v1/hrm/master/states/',
    createDistributionCenter: '/api/v1/hrm/master/distribution-centre/create',
    getSplashMessage: '/api/v1/hrm/master/flashMessage/search',
    saveSplashMessage: '/api/v1/hrm/master/flashMessage',
    saveProductSearch: '/api/v1/hrm/master/productSearch',
    getAsvTypes: '/api/v1/hrm/master/alternate-source-vendors'
} 

export const userApiUrl = {
    getAllUsers: '/api/v1/hrm/users',
    getUserDcMappingStatus: '/api/v1/hrm/users/getUserDcMappingStatus/',
    getUserRoles: '/api/v1/hrm/users/roles',
    getUsersDcStatus: '/api/v1/hrm/users/userMappedToDc/',
    getUserDetails: '/api/v1/hrm/users/user/',
    getUserDcDetails: '/api/v1/hrm/users/userDcMapping/',
    searchUsers: '/api/v1/hrm/users/search',
    downloadExcelUsersList: '/api/v1/hrm/users/search/excel/download'
}

export const workflowApiUrl = {
    getMessages: '/api/v1/hrm/workflow/getAllMessages',
    getRecipientList: '/api/v1/hrm/workflow/getAllUserMailIds',
    sendMessage: '/api/v1/hrm/workflow/sendMessages'
}

export const eventApiUrl = {
    getCustomerAccountData: '/api/v1/hrm/events/affectedCustomerDashboard',
    getCustomerAccountEventsData: '/api/v1/hrm/events/eventByAccount/account',
    updateAcknowledgeUndeliverable: '/api/v1/hrm/events/eventByAccount/status/',
    deleteFolder: '/api/v1/hrm/events/deleteFolder',
    eventSearch: '/api/v1/hrm/events/eventReceiver',
    msgCount: '/api/v1/hrm/events/messages/dashboard/count/',
    customerAckSearch: '/api/v1/hrm/events/affectedCustomerDashboard/acknowledge/filter',
    getAffectedItems: '/api/v1/hrm/events/eventmanagement/affecteditems/',
    saveAffectedItems: '/api/v1/hrm/events/affectedItems',
    lotSearch: '/api/v1/hrm/events/lots/',
    downloadExcelAffectedCustomersList: '/api/v1/hrm/events/affectedCustomerExportEvents/EVENT',
    downloadExcelAffectedCustomerEventsList: '/api/v1/hrm/events/affectedCustomerExportEvents/account',
    getaffectedDcData: '/api/v1/hrm/eventSummary/affectedDcs/',
    getEventNotes: '/api/v1/hrm/events/event/note/',
    getGeneralInfo:'/api/v1/hrm/events/generalInformation/',
    productInformation: '/api/v1/hrm/events/productInformation/',
    productReturnDetail: '/api/v1/hrm/events/productReturnDetail/',
    getQuarantineTblData:'/api/v1/hrm/events/quarantine/pagination/search'
}